import { useState, useEffect } from 'react'
import { bookshelfApi } from '@!/Api/user'
import { useToast } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { userHashAtom } from '@!/atoms/userInfoAtom'

export const useBookshelf = () => {
  const [userHash] = useAtom(userHashAtom)
  const [searchKeyword, setSearchKeyword] = useState('')
  const [sortType, setSortType] = useState('buy')
  const [bookshelf, setBookshelf] = useState([])
  const [token, setToken] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  useEffect(() => {
    if (userHash) {
      setToken(null)
      fetchBookshelf()
    }
  }, [userHash, sortType, searchKeyword])

  const fetchBookshelf = async (nextToken = null) => {
    if (!userHash) return

    setIsLoading(true)
    try {
      const data = await bookshelfApi(sortType, searchKeyword, nextToken)
      setBookshelf((prev) => (nextToken ? [...prev, ...(data.bookshelf || [])] : data.bookshelf || []))
      setToken(data.next_token)
    } catch {
      toast({
        title: 'Notification',
        description: '本棚の読み込みに失敗しました。',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    token,
    fetchBookshelf,
    sortedBooks: bookshelf,
    searchKeyword,
    sortType,
    handleSearch: setSearchKeyword,
    changeSortType: setSortType,
  }
}
